"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isErr = exports.isOk = exports.parseJsonAsResult = exports.JSONParseError = exports.JSONParseErrorType = exports.RootError = exports.makeAsyncThrowable = exports.makeThrowable = exports.throwIfError = exports.Err = exports.Ok = void 0;
var Ok = function (result) { return ({
    ok: true,
    result: result,
}); };
exports.Ok = Ok;
var Err = function (error) { return ({
    ok: false,
    error: error,
}); };
exports.Err = Err;
function throwIfError(result, errorModifier) {
    if (!result.ok) {
        if (errorModifier) {
            throw errorModifier(result.error);
        }
        throw result.error;
    }
    return result.result;
}
exports.throwIfError = throwIfError;
function makeThrowable(f, errorModifier) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return throwIfError(f.apply(void 0, args), errorModifier);
    };
}
exports.makeThrowable = makeThrowable;
function makeAsyncThrowable(f, errorModifier) {
    var _this = this;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return __awaiter(_this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, f.apply(void 0, args)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, throwIfError(result, errorModifier)];
                }
            });
        });
    };
}
exports.makeAsyncThrowable = makeAsyncThrowable;
var RootError = /** @class */ (function (_super) {
    __extends(RootError, _super);
    function RootError(errorType) {
        var _this = _super.call(this) || this;
        _this.errorType = errorType;
        // @ts-ignore
        if (errorType.toString) {
            // @ts-ignore
            _this.name = errorType.toString();
        }
        return _this;
    }
    return RootError;
}(Error));
exports.RootError = RootError;
exports.JSONParseErrorType = 'JsonParseError';
// tslint:disable-next-line:max-classes-per-file
var JSONParseError = /** @class */ (function (_super) {
    __extends(JSONParseError, _super);
    function JSONParseError(error) {
        var _this = _super.call(this, exports.JSONParseErrorType) || this;
        _this.error = error;
        return _this;
    }
    return JSONParseError;
}(RootError));
exports.JSONParseError = JSONParseError;
function parseJsonAsResult(data) {
    try {
        return (0, exports.Ok)(JSON.parse(data));
    }
    catch (error) {
        return (0, exports.Err)(new JSONParseError(error));
    }
}
exports.parseJsonAsResult = parseJsonAsResult;
function isOk(result) {
    return result.ok;
}
exports.isOk = isOk;
function isErr(result) {
    return !result.ok;
}
exports.isErr = isErr;
//# sourceMappingURL=result.js.map